import { z } from 'zod';
import { techniqueCategorySchema, difficultySchema } from '../constants/techniques.js';
import { userIdSchema } from './user-id.js';
// ---------------------------------------------------------------------------
// Cooking Technique (global catalog)
// ---------------------------------------------------------------------------
export const CookingTechniqueSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    description: z.string().nullable().default(null),
    category: techniqueCategorySchema,
    difficulty: difficultySchema,
    estimated_duration: z.number().int().positive().nullable().default(null),
    steps: z.array(z.string()).default([]),
    tips: z.array(z.string()).default([]),
    image_url: z.string().url().nullable().default(null),
    video_url: z.string().url().nullable().default(null),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
// ---------------------------------------------------------------------------
// User Cooking Technique (overrides & personal techniques)
// ---------------------------------------------------------------------------
export const UserCookingTechniqueSchema = z.object({
    id: z.string().uuid(),
    user_id: userIdSchema,
    base_technique_id: z.string().uuid().nullable().default(null),
    name: z.string().min(1),
    description: z.string().nullable().default(null),
    category: techniqueCategorySchema,
    difficulty: difficultySchema,
    estimated_duration: z.number().int().positive().nullable().default(null),
    steps: z.array(z.string()).default([]),
    tips: z.array(z.string()).default([]),
    image_url: z.string().url().nullable().default(null),
    video_url: z.string().url().nullable().default(null),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
// ---------------------------------------------------------------------------
// Form validation schema (create / edit)
// ---------------------------------------------------------------------------
export const TechniqueFormSchema = z.object({
    name: z.string().min(1).max(255),
    description: z.string().nullable().default(null),
    category: techniqueCategorySchema,
    difficulty: difficultySchema,
    estimated_duration: z.number().int().positive().nullable().default(null),
    steps: z.array(z.string()).default([]),
    tips: z.array(z.string()).default([]),
    image_url: z.string().url().nullable().default(null),
    video_url: z.string().url().nullable().default(null),
});
//# sourceMappingURL=cooking-technique.js.map